/* Autogenerated file. Do not modify */
define([], function() {
    'use strict';
    var skins = {};
     skins['wysiwyg.common.components.facebooklikebox.viewer.skins.FacebookLikeBoxSkin'] = {
  "react": [
    [
      "div",
      "likeboxContainer",
      [],
      {},
      [
        "iframe",
        "iframe",
        [],
        {
          "allowtransparency": "true",
          "scrolling": "auto"
        }
      ]
    ]
  ],
  "css": {
    "%likeboxContainer": "position:absolute;top:0;right:0;bottom:0;left:0;",
    "%[data-state~=\"bgStyle-light\"] %likeboxContainer": "background-color:#fff;",
    "%[data-state~=\"bgStyle-dark\"] %likeboxContainer": "background-color:#000;",
    "%[data-state~=\"bgStyle-noBg\"] %likeboxContainer": "background-color:transparent;",
    "%iframe": "border:0;box-sizing:border-box;width:100%;height:100%;"
  }
}

    return skins;
});
